<template>
  <div>
    <span style="font-size: 18px">{{ label }}</span><span v-if="labelRequired" style="color: #003366; font-size: 20px">*</span>
    <br/>
  </div>
</template>

<script>
export default {
  name: "ScreeningLabelComponent",
  props: {
    label: {
      type: String,
      default: ''
    },
    labelRequired:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>